import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, OnChanges, signal, computed, NO_ERRORS_SCHEMA } from '@angular/core';
import { ConfigSchemaFlowDefinition } from '../../../models/config-schema.model';
import { FlowDefinition } from '../../../models/flow.model';
import { Enums } from '../../../shared/enums';
import { IMPORTS } from './_imports';
import { Utils } from '../../../shared/utils';

@Component({
    selector: 'flow-definition-item',
    templateUrl: './flow-definition-item.component.html',
    styleUrl: './flow-definition-item.component.scss',
    standalone: true,
    imports: IMPORTS,
    schemas: [NO_ERRORS_SCHEMA]
})
export class FlowDefinitionItemComponent implements OnInit, OnChanges {
    // #region [ViewChild]
    @ViewChild('contextModeRef') contextModeRef: ElementRef<HTMLElement>;
    // #endregion

    // #region [Type props]
    FlowDefinitionItemActionType = Enums.FlowDefinitionItemActionType;
    Utils = Utils;
    // #endregion

    // #region [signals]
    $model = signal(null as FlowDefinition);
    $isContextMode = signal(false);
    $isLastContextIndex = signal(false);
    $hasReachedMaxLimit = signal(false);
    $hasFilteredFlowItemInContext = signal(false);
    $contextModeDispatcherId = signal(null as string);
    $dispatcherContextId = signal(null as string);
    $isDispatcherDiretory = signal(false);
    $isRemovingFromDirectory = signal(false);
    // #endregion

    // #region [computeds]
    $hasTemporalHotConfigs = computed(() => {
        if (!this.$model().configSchema) return false;
        let configSchema = JSON.parse(this.$model().configSchema) as ConfigSchemaFlowDefinition;
        return configSchema.hasAutomaticFlowDefinitionDeactivation || configSchema.hasAutomaticFlowInstanceCancellation;
    });
    $shouldShowMoveUpButton = computed(() => {
        return this.$model().contextId != null
            && this.$model().contextId == this.$dispatcherContextId()
            && this.$model().contextIndex > 0;
    });
    $shouldShowMoveDownButton = computed(() => {
        return this.$model().contextId != null
            && this.$model().contextId == this.$dispatcherContextId()
            && !this.$isLastContextIndex();
    });
    $shouldShowAddButton = computed(() => {
        return this.$model().id != this.$contextModeDispatcherId()
            && (
                this.$model().contextId == null
                || this.$model().contextId != this.$dispatcherContextId()
            );
    });
    $shouldShowRemoveButton = computed(() => {
        return this.$model().contextId != null
            && this.$model().contextId == this.$dispatcherContextId();
    });
    $isInContext = computed(() => this.$model().contextId != null);
    $isInDirectory = computed(() => this.$model().flowInboxDirectoryId != null);
    // #endregion

    // #region [Input/Output]
    @Input() _model: FlowDefinition;
    @Input() _isContextMode: boolean;
    @Input() _isLastContextIndex: boolean;
    @Input() _hasReachedMaxLimit: boolean;
    @Input() _hasFilteredFlowItemInContext: boolean;
    @Input() _contextModeDispatcherId: string;
    @Input() _dispatcherContextId: string;
    @Input() _isDispatcherDiretory: boolean;
    @Input() _isRemovingFromDirectory: boolean;
    @Output() _actionEvent = new EventEmitter<{ model: FlowDefinition, actionType: Enums.FlowDefinitionItemActionType }>();
    // #endregion

    constructor(public element: ElementRef) { }

    ngOnInit() { }

    ngOnChanges() {
        this.$model.set(this._model);
        this.$isContextMode.set(this._isContextMode);
        this.$isLastContextIndex.set(this._isLastContextIndex);
        this.$hasReachedMaxLimit.set(this._hasReachedMaxLimit);
        this.$hasFilteredFlowItemInContext.set(this._hasFilteredFlowItemInContext);
        this.$contextModeDispatcherId.set(this._contextModeDispatcherId);
        this.$dispatcherContextId.set(this._dispatcherContextId);
        this.$isDispatcherDiretory.set(this._isDispatcherDiretory);
        this.$isRemovingFromDirectory.set(this._isRemovingFromDirectory);
    }

    executeAction(actionType: Enums.FlowDefinitionItemActionType) {
        if (this.$isRemovingFromDirectory()) return;

        if ([Enums.FlowDefinitionItemActionType.MoveUpInContext, Enums.FlowDefinitionItemActionType.MoveDownInContext].includes(actionType)) {
            if (this.$hasFilteredFlowItemInContext()) return;
        }

        if ([Enums.FlowDefinitionItemActionType.AddItemToContext].includes(actionType)) {
            if (this.$hasReachedMaxLimit()) return;
        }

        this._actionEvent.emit({
            model: this.$model(),
            actionType: actionType
        });
    }

    // #region [===== private methods =====]
    // #endregion
}
